import Table from '@/components/common/Table'
import ClaimHandlingTableHook from './ClaimHandlingTable.hook'
import AcceptHealthClaimModal from '@/components/feature/HealthClaimPage/AcceptHealthClaimModal'
import ChangeOwnerModal from '@/components/feature/HealthClaimPage/ChangeOwnerModal'
import {
  BoxAction,
  BoxSearch,
  Button,
  HeaderWrapper,
  RadioGroup,
  SearchIcon,
  SearchInput,
  SelectedRow,
} from './styles'
import { PlusOutlined } from '@ant-design/icons'
import { validatePerm } from '@/libs/validatePermission'
import { BACKOFFICE_USER_PERMISSION } from '@/constant/BACKOFFICE_PERMISSION'
import PreviewPdfModal from './components/PreviewPdfModal'
import CancelClaimModal from './components/CancelClaimModal'

const ClaimHandlingTable = () => {
  const {
    isModalOpen,
    isCancelClaimModalOpen,
    cancelClaimNumber,
    isCancelClaimPending,
    selectClaimFormId,
    selectClaimNumber,
    selectInsuredName,
    getColumnsByType,
    radioOptions,
    selectTableType,
    getDataByType,
    isTableLoading,
    user,
    inputValue,
    onSearch,
    onChangeTableType,
    onTableChange,
    redirectToCreateClaimDetailPage,
    documentUrl,
    setDocumentUrl,
    handleCloseCancelClaimModal,
    handleConfirmCancelClaim,
    selectedRowKey,
    setSelectedRowKey,
    isChangeOwnerModalOpen,
    setIsChangeOwnerModalOpen,
    changeOwnerClaimFormId,
    changeOwnerCurrentOwnerId,
  } = ClaimHandlingTableHook()
  const canCreateClaim = validatePerm([BACKOFFICE_USER_PERMISSION.CLM010103], user.permissions)
  const dataByType = getDataByType(selectTableType)

  return (
    <>
      <HeaderWrapper>
        <BoxSearch>
          <SearchInput
            placeholder="ค้นหาเลขกรมธรรม์, เลขรับแจ้ง, เลขเคลม, เบอร์โทร, ชื่อ-นามสกุล ผู้เอาประกันภัย"
            prefix={<SearchIcon />}
            value={inputValue}
            onChange={onSearch}
          />
        </BoxSearch>
        <BoxAction>
          <RadioGroup
            options={radioOptions}
            optionType="button"
            buttonStyle="solid"
            size="large"
            defaultValue={selectTableType}
            onChange={({ target: { value } }) => onChangeTableType(value)}
            data-testid="health-claim-tab-radio-group"
          />
          {canCreateClaim && (
            <Button type="primary" onClick={redirectToCreateClaimDetailPage}>
              <PlusOutlined />
              สร้างเคส
            </Button>
          )}
        </BoxAction>
      </HeaderWrapper>
      <Table
        rowKey="claimFormId"
        columns={getColumnsByType(selectTableType)}
        dataSource={dataByType.data?.data || []}
        loading={isTableLoading}
        scroll={{ x: 'max-content' }}
        pagination={{
          pageSizeOptions: [10, 25, 50, 100],
          showSizeChanger: true,
          total: dataByType.data?.meta.totalItems,
          current: dataByType.data?.meta.currentPage,
          defaultCurrent: 1,
          defaultPageSize: 10,
          pageSize: dataByType.data?.meta.itemsPerPage,
        }}
        onChange={(pagination, filter, sorter) => onTableChange(pagination, filter, sorter)}
        onRow={(record) => ({
          onClick: () => setSelectedRowKey(record.claimFormId),
        })}
        rowClassName={(record) => (record.claimFormId === selectedRowKey ? SelectedRow : '')}
      />
      <AcceptHealthClaimModal
        claimFormId={selectClaimFormId}
        isModalOpen={isModalOpen}
        claimNumber={selectClaimNumber}
        insuredPersonName={selectInsuredName}
      />
      <ChangeOwnerModal
        isModalOpen={isChangeOwnerModalOpen}
        claimFormId={changeOwnerClaimFormId}
        currentOwnerId={changeOwnerCurrentOwnerId}
        onClose={() => setIsChangeOwnerModalOpen(false)}
      />
      <CancelClaimModal
        isModalOpen={isCancelClaimModalOpen}
        claimNumber={cancelClaimNumber}
        onClose={handleCloseCancelClaimModal}
        onConfirm={handleConfirmCancelClaim}
        isLoading={isCancelClaimPending}
      />
      {documentUrl && (
        <PreviewPdfModal
          pdf={documentUrl}
          onCancel={() => {
            setDocumentUrl(null)
          }}
          visible={!!documentUrl}
        />
      )}
    </>
  )
}

export default ClaimHandlingTable
